import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Config from '../../core/config';

import Paragraph from '../UI/Paragraph';
import Link from '../UI/Link';
import Modal from '../Modal/Modal';

import store from '../../store/createStore';

const ErrorMessage = ({
  className,
  shortLogo,
  isModalActive,
  data,
  closeBtn,
  closeBtnCta,
  onClickHandler,
  transInfo,
}) => {
  const [showModal, setShowModal] = useState(isModalActive);

  if (!data) {
    return null;
  }
  const {
    bgImage,
    background,
    title,
    description,
    text,
    linkTitle,
    linkUrl,
    buttonText,
    buttonLink,
    secondButtonText,
    secondButtonLink,
    sendPayment,
    gtmEvent,
  } = data;

  const handleGtm = () => {
    if (gtmEvent && window.dataLayer) {
      const { clientAgreePopIn } = Config.gtm;

      return window.dataLayer.push(clientAgreePopIn);
    }
    return null;
  };

  const onClick = () => {
    handleGtm();
    setShowModal(false);
  };

  if (isModalActive) {
    return showModal ? (
      <Modal
        className={className}
        closeModalHandler={() => setShowModal(false)}
        closeBtn={closeBtn || false}
      >
        <div className="Error">
          <div className="Error__message">
            <Paragraph className="logo-wrapper">{shortLogo}</Paragraph>
            <h3 className="Error__  message__title">{title}</h3>
            {description || text ? (
              <Paragraph className="Error__message__description">
                {description || ReactHtmlParser(text)}
              </Paragraph>
            ) : null}
            {(linkUrl && linkTitle) || (buttonLink && buttonText) ? (
              <Link
                href={linkUrl || buttonLink}
                className={`Error__message__button ${secondButtonLink ? 'margin-b' : ''}`}
              >
                {linkTitle || buttonText}
              </Link>
            ) : null}
            {buttonText && sendPayment ? (
              <button
                type="button"
                className={`Error__message__button ${secondButtonLink ? 'margin-b' : ''}`}
                onClick={onClick}
              >
                {buttonText}
              </button>

            ) : null}

            {secondButtonLink && secondButtonText ? (
              <p>
                <Link href={secondButtonLink} className="Error__message__button">
                  {secondButtonText}
                </Link>
              </p>
            ) : null}

            { closeBtnCta && buttonText ? (
              <button
                type="button"
                className={`Error__message__button ${secondButtonLink ? 'margin-b' : ''}`}
                onClick={() => setShowModal(false)}
              >
                {buttonText}
              </button>
            ) : null}
          </div>
        </div>
      </Modal>
    ) : null;
  }

  return (
    <article
      className={`Error ${className}`}
      style={{ background: `url(${bgImage || background}) no-repeat center` }}
    >
      <div className="Error__message">
        {title ? (
          <h1 className={`Error__message__title ${shortLogo ? 'font-bigger' : null}`}>
            {shortLogo}
            {title}
          </h1>
        ) : null}
        {description || text ? (
          <Paragraph className="Error__message__description">{description || text}</Paragraph>
        ) : null}
        {(linkUrl && linkTitle) || (buttonLink && buttonText) ? (
          <Link href={linkUrl || buttonLink} className="Error__message__button">
            {linkTitle || buttonText}
          </Link>
        ) : null}
      </div>
    </article>
  );
};

export default ErrorMessage;

ErrorMessage.propTypes = {
  background: PropTypes.string,
  bgImage: PropTypes.string,
  className: PropTypes.string,
  shortLogo: PropTypes.element,
  isModalActive: PropTypes.bool,
  gtmEvent: PropTypes.string,
  data: PropTypes.shape({
    bgImage: PropTypes.string,
    background: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.string,
    linkTitle: PropTypes.string,
    linkUrl: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    secondButtonText: PropTypes.string,
    secondButtonLink: PropTypes.string,
    sendPayment: PropTypes.bool,
    gtmEvent: PropTypes.bool,
  }).isRequired,
  closeBtn: PropTypes.bool,
  sendPayment: PropTypes.bool,
  onClickHandler: PropTypes.func.isRequired,
};
ErrorMessage.defaultProps = {
  background: null,
  bgImage: null,
  className: null,
  shortLogo: null,
  gtmEvent: null,
  isModalActive: false,
  closeBtn: false,
  sendPayment: null,
};
